let csrfToken

export function getCsrfToken() {
  if (csrfToken) return csrfToken

  const csrfMeta = document.head.querySelector('[name=csrf-token][content]')
  return (csrfToken = csrfMeta ? csrfMeta.content : '')
}
